// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1nUAE","disabled":"FileBtn_disabled__-cqzZ","warn":"FileBtn_warn__3-k75","fade":"FileBtn_fade__2LH2L"};